import React from 'react';
import classes from './style.module.scss';
import Exclamation from 'assets/images/icons/JSX/Exlamation';
import getWarningText from 'utils/getWarningText';
import Tooltip from 'components/Tooltip';
import uniqid from 'uniqid';

const escapeHtml = (value = "") =>
    String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

export default ({ warning, className }) => {
    const id = uniqid("tooltip-");
    const warningText = escapeHtml(getWarningText(warning));

    return (
        <div
            className={`${classes.warning} ${className && className}`}
            data-html
            data-tip={`<span style="display:block;max-width:14rem;">${warningText}</span>`}
            data-for={`${id}_warningTip`}
        >
            <Exclamation />
            <Tooltip id={`${id}_warningTip`} />
        </div>
    )
}